import { useState } from 'react';

export default function StandardLayout({ children, h6, pageH1, pageH1Extras, subtitle, button, description, menu, breadcrumb }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const truncatedDescription = description?.length > 130 ? description.substring(0, 130) + '...' : description;

  const handleShowDescription = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="container-fluid pb-6">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="header mb-4">
            <div className="header-body">
              <div className="row align-items-center">
                <div className="col">
                  {h6 && <h6 className="header-pretitle">{h6}</h6>}

                  {pageH1Extras ? (
                    <div className="title">
                      <h1 className="header-title d-inline-block">{pageH1}</h1>
                      {pageH1Extras}
                    </div>
                  ) : pageH1 ? (
                    <h1 className="header-title">{pageH1}</h1>
                  ) : null}

                  {subtitle && <h5 className="header-subtitle">{subtitle}</h5>}
                </div>

                <div className="col-auto">{button}</div>
              </div>

              {description && (
                <div className="row mt-2">
                  <div className="col d-flex align-items-center">
                    <p className="text-muted fs-5 mb-0 category-description" id="description">
                      {isExpanded ? description : truncatedDescription}
                    </p>
                  </div>

                  {description.length > 130 && (
                    <div className="col d-flex align-items-center">
                      <button className="btn btn-link fs-5 py-0 px-1" type="button" onClick={handleShowDescription}>
                        <i className={`fe fe-chevron-down rotateable ${isExpanded ? 'rotate' : ''}`} />
                      </button>
                    </div>
                  )}
                </div>
              )}

              {menu}
            </div>
            {breadcrumb}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
